import { render } from "./DettaglioOdv.vue?vue&type=template&id=e368514c&scoped=true&ts=true"
import script from "./DettaglioOdv.vue?vue&type=script&lang=ts"
export * from "./DettaglioOdv.vue?vue&type=script&lang=ts"

import "./DettaglioOdv.vue?vue&type=style&index=0&id=e368514c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e368514c"]])

export default __exports__